// extracted by mini-css-extract-plugin
var _1 = "checkout-DQQNb";
export { _1 as "checkout" }
